import customAxios from './customAxios';
import { FETCH_USER_ADDRESSES, FETCH_MY_POLICIES,
         UPDATE_USER_DETAILS, CLEAR_USER_DETAILS, UPDATE_USER_ADDRESS } from "./types";
import * as vehicleService from '../common/services/vehicle.service';

export const getUser = () => async (dispatch, getState) => {

    const url = `/syws-user/api/user`;

    let res,
    payload = {};


    try{
        res = await customAxios.get(url);
    } catch (error) {
        console.log(error);
    }

    if(res?.data && !res?.data?.messageCode) {
        payload = res?.data;
    }

    //console.log(res?.data)

    dispatch({type: UPDATE_USER_DETAILS, payload: payload});
  }

  export const getUserAddresses = () => async (dispatch, getState) => {

    const url = `/syws-user/api/user/addresses`;

    let res,
    payload = [];

    try{
        res = await customAxios.get(url);

    } catch (error) {
      console.log(error);
    }

    if(res?.data && !res?.data?.status ) {
      payload = res?.data ;
    }

    // console.log(res.data)

    dispatch({type: FETCH_USER_ADDRESSES, payload: payload});
  }


  //This to be used only for logout
  export const clearUserDetails = () => (dispatch, getState) => {
    dispatch({type: CLEAR_USER_DETAILS, payload: {}});
  }

  export const updateUser = (body) => async (dispatch, getState) => {
    if(!body) return;

    const url = `/syws-user/api/user`;

    // body = Object.keys(body).reduce((acc, curr, i)=> {

    //     return acc + `${i>0 ? '&' :''}${curr}=${body[curr]}`;
    // }, "");

    // body = encodeURI(body);

    let res;

    try{
        res = await customAxios.post(url, body);
    } catch (error) {
        console.log(error);
    }

    if(res?.data && res?.data?.status === 0) {
        await dispatch(getUser());
    }

    console.log(res?.data)
  }

  export const updateAddress = (body) => async (dispatch, getState) => {
    if(!body) return;

    const url = `/syws-user/api/user/updateAddress`;

    let res;

    try{
        res = await customAxios.post(url, body);
    } catch (error) {
        console.log(error);
    }

    if(res?.data && res?.data?.status === 0) {
        await dispatch(getUserAddresses());
    }
    //console.log(body)
    //console.log(res?.data)
  }

  export const addAddress = (address) => async (dispatch, getState) => {
    if(!address) return;

    const body = vehicleService.mapNewUserAddress(address, true, true);

    const url = `/syws-user/api/user/updateAddress`;

    let res;

    try{
        res = await customAxios.post(url, body);
    } catch (error) {
        console.log(error);
    }

    if(res?.data && res?.data?.status === 0) {
        await dispatch(getUserAddresses());
    }
    //console.log(body)
    //console.log(res?.data)
  }

  export const deleteUserAddress = (addressId) => async (dispatch, getState) => {
        if(!addressId) return;

        const url = `/syws-user/api/user/deleteAddress?addressId=${addressId}`;

        let res;

        try{
            res = await customAxios.get(url);
        } catch (error) {
            console.log(error);
        }

        if(res?.data && res?.data?.status === 0) {
            await dispatch(getUserAddresses());
        }

        console.log(res?.data)
  }

  export const updateUserDetails = (data) => (dispatch, getState) => {

    dispatch({type: UPDATE_USER_DETAILS, payload: data });
  }

  export const updateUserAddress = (data) => (dispatch, getState) => {
    //data = data || {};
    dispatch({type: UPDATE_USER_ADDRESS, payload: data });
  }

  export const getMyPolicies = () => async (dispatch, getState) => {

    const url = `/syws-ins-vehicle/api/insVehicle/insContracts`;

    let res, payload;

    try{
        res = await customAxios.get(url);

    } catch (error) {
      console.log(error);
    }

    if(res?.data && !res?.data?.status ) {
      payload = res?.data;
    }
    
    dispatch({type: FETCH_MY_POLICIES, payload: payload });
  }
 

  //------------------------------------------email Change not actions ---------------

  export const changeEmail = (newEmail, oldEmail) => {
    const url = '/syws-auth/email/change'

    const body = {newEmail, oldEmail};

    return customAxios.post(url, body);
  }

  export const authorizeChangeEmail = (documentId, code) => {

    let params = `documentId=${documentId}&code=${code}`;

    params = encodeURI(params);

    const url = `/syws-auth/email/change?${params}`;

    return customAxios.get(url);
  }